import React, { useMemo } from 'react';
import './style.scss';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { LinkProp } from '../../../interfaces/LinkProp';
import { useAssets } from '../../../contexts/assets';

interface FinalLink {
  pathname: string;
  search?: string;
  state?: any;
}

interface LinkProps {
  children: React.ReactNode;
  to: LinkProp;
  color?: 'default' | 'white';
  external?: boolean;
  underline?: boolean;
  className?: string;
  style?: any;
  disableHover?: boolean;
  onClick?: () => any;
  noSound?: boolean;
}

const Link = ({
  children,
  to,
  color = 'default',
  external = false,
  underline = false,
  className = '',
  style = {},
  disableHover = false,
  onClick = () => {},
  noSound = false
}: LinkProps) => {
  const { sound } = useAssets();
  const finalClassName = useMemo(() => {
    return clsx(
      'link',
      color === 'white' ? 'link-white' : 'link-default',
      underline && 'link-underline',
      disableHover && 'link-no-hover',
      className
    );
  }, [color, underline, className]);

  const finalLink = useMemo<FinalLink>(() => {
    if (typeof to === 'string') {
      return { pathname: to };
    }
    return to;
  }, [to]);

  const handleClick = () => {
    if (onClick) {
      onClick();
      if (!noSound) {
        sound.click();
      }
    }
  };

  if (external) {
    return (
      <a
        href={finalLink.pathname}
        className={finalClassName}
        style={style}
        onClick={handleClick}
        target='_blank'
      >
        {children}
      </a>
    );
  }

  return (
    <RouterLink
      to={finalLink}
      state={finalLink.state}
      className={finalClassName}
      style={style}
      onClick={handleClick}
    >
      {children}
    </RouterLink>
  );
};

export default Link;
